import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map, of, switchMap } from 'rxjs';
import { SessionService } from '../../services/session.service';
import { SecuritySessionsApiActions, SecuritySessionsPageActions } from './security.actions';

@Injectable()
export class SecurityEffects {
  private readonly actions$ = inject(Actions);
  private readonly sessionService = inject(SessionService);

  readonly loadSessions$ = createEffect(() => this.actions$.pipe(
    ofType(SecuritySessionsPageActions.opened),
    switchMap(() => this.sessionService.getActiveSessions().pipe(
      map((sessions) => SecuritySessionsApiActions.loadSucceeded({ sessions })),
      catchError((error: { message?: string }) => of(SecuritySessionsApiActions.loadFailed({ error: error?.message ?? 'Unable to load sessions' }))),
    )),
  ));

  readonly revokeSession$ = createEffect(() => this.actions$.pipe(
    ofType(SecuritySessionsPageActions.revokeRequested),
    concatMap(({ requestId, sessionId }) => this.sessionService.revokeSession(sessionId).pipe(
      map(() => SecuritySessionsApiActions.revokeSucceeded({ requestId, sessionId })),
      catchError((error: { message?: string }) => of(SecuritySessionsApiActions.revokeFailed({ requestId, error: error?.message ?? 'Unable to revoke session' }))),
    )),
  ));

  readonly logoutAllSessions$ = createEffect(() => this.actions$.pipe(
    ofType(SecuritySessionsPageActions.logoutAllRequested),
    concatMap(({ requestId }) => this.sessionService.logoutAllSessions().pipe(
      map(() => SecuritySessionsApiActions.logoutAllSucceeded({ requestId })),
      catchError((error: { message?: string }) => of(SecuritySessionsApiActions.logoutAllFailed({ requestId, error: error?.message ?? 'Unable to close sessions' }))),
    )),
  ));
}
